import * as TypesHandout from '../types/types_handout';
import Vue from 'vue';
import _ from 'lodash';

function classifyArr(tarr, params) {
    /**
     * tarr 要转换结构的题目对象的数组；
     * params 用于分组的属性（目前只有'category'）
     * 返回值：一个题目分类的的数组，包含该分类的所有题目
     */
    let classifyArr = {};
    let finallyArr = [];
    let categoryList = [];
    tarr.forEach(item => {
        item[params] = item[params] === '' ? '未关联考法' : item[params]; // 无考法名称的，改为'未关联考法'
        if (!classifyArr[item[params]]) {
            classifyArr[item[params]] = [item];
        } else {
            classifyArr[item[params]].push(item);
        }
    });
    _.forEach(classifyArr, (item, key) => {
        categoryList.push(key);
        finallyArr.push({
            name: key, // 考法名
            value: item, // 题目列表
            isExpend: false, // 是否展开
            categoryList: categoryList // 考法的数组
        });
    });
    if (finallyArr && finallyArr.length) {
        finallyArr[0].isExpend = true; // 默认展开第一个分类
    }
    return finallyArr;
}

export default {
    state: {
    // 备课或讲义修改会同步到这里
        sessionName: '', // 讲义名称
        knowledgePoint: {}, // 讲义数据对象
        currentPoint: {}, // 讲义难度和知识点id
        basket: {}, // 存放要添加题目用的对象
        categoryArray: [], // 考法数组（包含折叠状态、显示tab）
        studentName: '', // 学生名
        checkAllQuestion: [], // 全选的题目
        deleteCheckQue: [], // 勾选后最终的题目
        stateQuestionLen: [],
        isCheck1: {}, // 例题的各个考法的全选的选中状态
        isCheck2: {}, // 习题的各个考法的全选的选中状态
        pages: {} // 讲义题目列表每个考法分类的分页的页数
    },
    mutations: {
        [TypesHandout.HANDOUT_SET_DETAIL](state, payload) {
            if (payload) {
                /**
                 * payload对象里有
                 * coursewareId: 讲义id,
                 * name: 讲义名,
                 * studentName: 学生名,
                 * teacherId: 老师id,
                 * studentId: 学生id,
                 * knowledgePoints: 讲义数据对象
                 */
                let knowledgePoint = payload.knowledgePoint;
                // 获取题目分类的数组
                if (knowledgePoint.practiceLessonQuestions && knowledgePoint.practiceLessonQuestions.length) {
                    knowledgePoint.newpracticeLessonQuestions = classifyArr(knowledgePoint.practiceLessonQuestions, 'category');
                } else {
                    knowledgePoint.newpracticeLessonQuestions = [];
                }
                if (knowledgePoint.withinLessonQuestions && knowledgePoint.withinLessonQuestions.length) {
                    knowledgePoint.newwithinLessonQuestions = classifyArr(knowledgePoint.withinLessonQuestions, 'category');
                } else {
                    knowledgePoint.newwithinLessonQuestions = [];
                }
                state.currentPoint = {
                    id: knowledgePoint.knowledgePointId,
                    difficulty: knowledgePoint.difficulty
                };
                state.sessionName = payload.name || '';

                // 2.6在线备课需要的考法列表 start
                // 提取并去重例题精讲和讲义习题里的全部考法
                let categoryArray = []; // 讲义题目考法的数组
                const categoryLen = knowledgePoint.categories.length; // 讲义题目考法的长度
                if (categoryLen) {
                    categoryArray = knowledgePoint.categories;
                }
                for (let i = 0; i < categoryLen; i++) { // 根据考法数量初始化分页器的值
                    Vue.set(state.pages, `w${i}`, 1);
                    Vue.set(state.pages, `p${i}`, 1);
                }
                let newCategory = [];
                if (categoryArray.length) {
                    _.uniq(categoryArray).forEach(item => { // 去重(好像没必要)后，改写结构
                        newCategory.push({
                            name: item.name, // 考法名
                            isExpendCategory: false, // 是否折叠
                            categoryTabType: 1, // 当前展示tab(1:例题,2:习题)
                            key: item.key // 考法的key
                        });
                    });
                    newCategory[0].isExpendCategory = true; // 默认展开第一个
                }

                // 把例题和习题里面的考法全设为newCategory里的考法
                // 把classifyArr函数中添加的categoryList改成讲义返回的categories（前后矛盾，意义不明）
                if (knowledgePoint.newpracticeLessonQuestions.length) {
                    knowledgePoint.newpracticeLessonQuestions.forEach(item => {
                        item.categoryList = _.uniq(categoryArray);
                    });
                }
                if (knowledgePoint.newwithinLessonQuestions.length) {
                    knowledgePoint.newwithinLessonQuestions.forEach(item => {
                        item.categoryList = _.uniq(categoryArray);
                    });
                }
                // 2.6在线备课需要的考法列表 end

                // 去除在线备课中的重复题 ----start
                // 给返回的讲义数据中的withinLessonQuestions，practiceLessonQuestions题目列表去重
                let withinLessonQue = knowledgePoint.withinLessonQuestions;
                withinLessonQue = _.uniqBy(withinLessonQue, 'id');
                let practiceLessonQues = knowledgePoint.practiceLessonQuestions;
                practiceLessonQues = _.uniqBy(practiceLessonQues, 'id');

                // 遍历已经按考法分类的例题、习题列表
                let allQue = [
                    {cateName: '例题', checkArr: []},
                    {cateName: '习题', checkArr: []}
                ];
                let newwithinLessonQues = knowledgePoint.newwithinLessonQuestions; // 被分类的例题
                for (let i = 0; i < newwithinLessonQues.length; i++) {
                    allQue[0].checkArr.push({
                        name: newwithinLessonQues[i].name, // 考法名
                        withLen: newwithinLessonQues[i].value.length // 题目数量
                    });
                    for (let j = 0; j < newwithinLessonQues[i].value.length; j++) {
                        newwithinLessonQues[i].value = _.uniqBy(newwithinLessonQues[i].value, 'id'); // 对已被分类的题目去重
                    }
                }

                let newpracticeLessonQues = knowledgePoint.newpracticeLessonQuestions; // 被分类的习题
                for (let i = 0; i < newpracticeLessonQues.length; i++) {
                    allQue[1].checkArr.push({
                        name: newpracticeLessonQues[i].name, // 考法名
                        withLen: newpracticeLessonQues[i].value.length // 题目数量
                    });
                    for (let j = 0; j < newpracticeLessonQues[i].value.length; j++) {
                        newpracticeLessonQues[i].value = _.uniqBy(newpracticeLessonQues[i].value, 'id'); // 对已被分类的题目去重
                    }
                }
                state.stateQuestionLen = allQue;
                // 去除在线备课中的重复题 ----end
                // 处理
                let allQuestion = [
                    {cateName: '例题', cateArr: []},
                    {cateName: '习题', cateArr: []}
                ];
                let newWith = knowledgePoint.newwithinLessonQuestions;
                let newPrac = knowledgePoint.newpracticeLessonQuestions;
                for (let index = 0; index < newWith.length; index++) {
                    Vue.set(state.isCheck1, 'check' + (Number(index) + 1), false); // 设置例题各个考法的选中状态
                    allQuestion[0].cateArr.push({
                        name: newWith[index].name, // 考法名
                        checkQues: []
                    });
                }
                for (let index = 0; index < newPrac.length; index++) {
                    Vue.set(state.isCheck2, 'check' + (Number(index) + 1), false); // 设置习题各个考法的选中状态
                    allQuestion[1].cateArr.push({
                        name: newPrac[index].name, // 考法名
                        checkQues: []
                    });
                }
                state.checkAllQuestion = allQuestion;
                // ---
                state.studentId = payload.studentId || '';
                state.coursewareId = payload.coursewareId || '';
                state.studentName = payload.studentName || '';
                state.knowledgePoint = knowledgePoint;
                state.categoryArray = newCategory;
            } else {
                state.sessionName = '';
                state.studentName = '';
                state.knowledgePoint = {};
                state.currentPoint = {};
            }
            // 清空试题篮
            state.basket = {};
        },
        [TypesHandout.HANDOUT_SYNC_SESSION_NAME](state, payload) {
            // payload 参数 name(课程标题)
            state.sessionName = payload || '';
        },
        // 添加讲法
        [TypesHandout.HANDOUT_ADD_CATEGORY](state, payload) {
            // payload 参数 currentClaasifyIndex  targetIndex targetName  questionStage (问题阶段 0: 课前 1：例题  2：习题 )
            const STAGE_ENUM = ['newpreLessonQuestions', 'newwithinLessonQuestions', 'newpracticeLessonQuestions'];
            let currentStage = STAGE_ENUM[payload.questionStage];
            let currentClaasifyIndex = payload.currentClaasifyIndex;
            // 找到该题对应位置，添加字段
            Vue.set(state.knowledgePoint[currentStage][currentClaasifyIndex].value[payload.currentIndex], 'teachingTip', payload.teachingTip);
        },
        // 操作问题，移动问题 向上，向下 mutations
        [TypesHandout.HANDOUT_MOVE_QUESTION](state, payload) {
            // payload 参数 currentClaasifyIndex  targetIndex targetName  questionStage (问题阶段 0: 课前 1：例题  2：习题 )
            const STAGE_ENUM = ['newpreLessonQuestions', 'newwithinLessonQuestions', 'newpracticeLessonQuestions'];
            let currentStage = STAGE_ENUM[payload.questionStage];
            let currentClaasifyIndex = payload.currentClaasifyIndex;
            // 交换info knowledgePoint 知识点下的问题位置
            const arr = _.get(state.knowledgePoint, [currentStage], []);
            let targetStage;
            arr.forEach(item => {
                if (item.name === payload.currentClassName) {
                    targetStage = item;
                }
            });
            targetStage = targetStage || {};
            let absIndex = Math.abs(payload.targetIndex - payload.currentIndex);
            let curInx = payload.currentIndex;
            let tarInx = payload.targetIndex;
            if (absIndex && curInx >= tarInx) {
                // splice  插入元素
                let temp = targetStage.value[payload.currentIndex];
                targetStage.value.splice(payload.targetIndex, 0, temp);
                targetStage.value.splice(payload.currentIndex + 1, 1);
            } else {
                let temp = targetStage.value[payload.currentIndex];
                targetStage.value.splice(payload.targetIndex + 1, 0, temp);
                targetStage.value.splice(payload.currentIndex, 1);
            }
            let sourceObj = state.knowledgePoint[currentStage];
            let targetIndex = _.findIndex(sourceObj, {name: payload.currentClassName});
            // 优先根据category的分类进行检索
            currentClaasifyIndex = targetIndex + 1 ? targetIndex : currentClaasifyIndex;
            Vue.set(sourceObj, currentClaasifyIndex, targetStage);
        },
        // 批量删除题目 ------- 3.0.2
        [TypesHandout.HANDOUT_SET_DELETEALL](state, payload) {
            // console.log('cccccc=====', payload);
            // payload 参数 currentIndex  questionStage (问题阶段 0: 课前  1：例题  2：习题 )
            const STAGE_ENUM = ['newwithinLessonQuestions', 'newpracticeLessonQuestions'];
            const STAGE_ENUM_BASKET = ['withinLessonQuestions', 'practiceLessonQuestions'];
            let currentClaasifyIndex = payload.currentClaasifyIndex; // 考法下标
            let currentQuesStage = payload.questionStage - 1; // 题目类型
            let deleArr = state.deleteCheckQue[currentQuesStage]['checkArr'][currentClaasifyIndex].che;

            let currentStageBasket = STAGE_ENUM_BASKET[currentQuesStage];
            let currentStage = STAGE_ENUM[currentQuesStage];
            // ['withinLessonQuestions', 'practiceLessonQuestions'];的数据
            let oldStage = state.knowledgePoint[currentStageBasket];
            for (let i = 0; i < deleArr.length; i++) {
                for (let j = 0; j < oldStage.length; j++) {
                    if (deleArr[i] === oldStage[j].id) {
                        oldStage.splice(j, 1);
                    }
                }
            }
            state.knowledgePoint[currentStageBasket] = oldStage;

            // ['newwithinLessonQuestions', 'newpracticeLessonQuestions'];的数据
            let newWithLesson = state.knowledgePoint[currentStage];
            let currentIndex = 0; // 因为考法的排序混乱，因此先找出对应的索引，在删除
            // 首先根据考法名字，得到vuex中这个考法的下标
            for (let m = 0; m < newWithLesson.length; m++) {
                if (payload.currentCateName === newWithLesson[m].name) {
                    currentIndex = m;
                }
            }
            let newWith = state.knowledgePoint[currentStage][currentIndex].value;
            if (state.knowledgePoint[currentStage][currentIndex]) {
                for (let i = 0; i < deleArr.length; i++) {
                    for (let j = 0; j < newWith.length; j++) {
                        if (deleArr[i] === newWith[j].id) {
                            newWith.splice(j, 1);
                        }
                    }
                }
            }
            state.knowledgePoint[currentStage][currentIndex].value = newWith;
            // 最终选择的题目，然后在删除批量删除的题目，然后进行回填
            // state.deleteCheckQue   deleArr
            state.deleteCheckQue[currentQuesStage]['checkArr'][currentClaasifyIndex].che = [];
        },
        // 操作问题，删除问题 mutations --- 因为需要保持单个删除题目的操作，因此这个逻辑还要保留
        [TypesHandout.HANDOUT_DELETE_QUESTION](state, payload) {
            // payload 参数 currentIndex  questionStage (问题阶段 0: 课前  1：例题  2：习题 )
            const STAGE_ENUM = ['newpreLessonQuestions', 'newwithinLessonQuestions', 'newpracticeLessonQuestions'];
            const STAGE_ENUM_BASKET = ['preLessonQuestions', 'withinLessonQuestions', 'practiceLessonQuestions'];
            let currentStageBasket = STAGE_ENUM_BASKET[payload.questionStage];
            let currentStage = STAGE_ENUM[payload.questionStage];
            let currentPoint = state.currentPoint;
            let currentClaasifyIndex = payload.currentClaasifyIndex;
            let oldStageIndex = _.findIndex(state.knowledgePoint[currentStageBasket], { id: payload.id });
            state.knowledgePoint[currentStageBasket].splice(oldStageIndex, 1);
            const arr = _.get(state.knowledgePoint, [currentStage], []);
            let targetStage;
            arr.forEach(item => {
                if (item.name === payload.currentClassName) {
                    targetStage = item.value || [];
                }
            });
            targetStage.splice(payload.currentIndex, 1);
            if (state.basket[currentPoint.id]) {
                let basketIdx = _.findIndex(state.basket[currentPoint.id][currentStageBasket], { id: payload.id });
                state.basket[currentPoint.id][currentStageBasket].splice(basketIdx, 1);
            }
        },
        // 操作问题，换组问题 mutations
        [TypesHandout.HANDOUT_TURN_QUESTION](state, payload) {
            const STAGE_ENUM = ['newpreLessonQuestions', 'newwithinLessonQuestions', 'newpracticeLessonQuestions'];
            let currentStage = STAGE_ENUM[payload.questionStage]; // 原先在的位置
            let turnStage = STAGE_ENUM[payload.turnStage]; // 要去的位置
            let currentClaasifyIndex = payload.currentClaasifyIndex; // 移动的数据所在的组索引
            const arr = _.get(state.knowledgePoint, [currentStage], []);
            let targetStage;
            arr.forEach(item => {
                if (item.name === payload.currentName) {
                    targetStage = item;
                }
            });
            let targetStagePage = _.cloneDeep(state.knowledgePoint[turnStage]); // 要去的组
            const index = _.findIndex(targetStagePage, item => { // 目标组所在的索引
                return item.name === payload.targetName;
            });
            if (currentStage === turnStage && index === payload.currentIndex && payload.currentName === payload.targetName) {
                return;
            }
            const currentArr = targetStage.value.splice(payload.currentIndex, 1);
            if (currentStage === turnStage) {
                targetStagePage.forEach(ele => {
                    if (ele.name === targetStage.name) {
                        ele.value = targetStage.value;
                    }
                });
            }
            // 将这道题的考法名称改为新的考法名称
            (currentArr[0] || {}).category = payload.targetName;
            if (index === -1) {
                targetStagePage.push({
                    name: payload.targetName,
                    value: [currentArr[0]],
                    isExpend: false,
                    categoryList: state.categoryArray
                });
            } else {
                targetStagePage[index].value.push(currentArr[0]);
            }

            Vue.set(state.knowledgePoint[currentStage], currentClaasifyIndex, targetStage);
            Vue.set(state.knowledgePoint, turnStage, targetStagePage);
        },
        // 将所选问题添加到试题篮中 mutations
        [TypesHandout.HANDOUT_KB_IN_BASKET](state, payload) {
            // payload 参数 pointId (备课知识点ID) difficulty (备课知识点难度) stage 阶段 category 语法  question 问题整体
            const STAGE_ENUM = ['preLessonQuestions', 'withinLessonQuestions', 'practiceLessonQuestions'];
            let currentStage = STAGE_ENUM[payload.stage];
            let findObj = payload.question.type === 2 ? {
                question: payload.question.question,
                answer: payload.question.answer,
                analysis: payload.question.analysis
            } : { id: payload.question.id };
            // 防重复添加
            if (state.basket[payload.pointId] && state.basket[payload.pointId][currentStage] && _.findIndex(state.basket[payload.pointId][currentStage], findObj) > -1) {
                return false;
            }
            let question = payload.question.type === 2 ? Object.assign({}, payload.question, {
                isNew: true,
                type: 2,
                category: payload.category
            }) : {
                id: payload.question.id,
                isNew: true,
                question: payload.question,
                type: payload.question.type || 1,
                category: payload.category,
                difficulty: payload.question.difficulty
            };
            if (!state.basket[payload.pointId]) {
                state.basket[payload.pointId] = {};
                state.basket[payload.pointId][currentStage] = [question];
            } else if (!state.basket[payload.pointId][currentStage]) {
                state.basket[payload.pointId][currentStage] = [question];
            } else {
                state.basket[payload.pointId][currentStage].push(question);
            }
            const pageData = state.knowledgePoint[currentStage];
            const allPageData = state.knowledgePoint;
            pageData.push(_.cloneDeep(question));
            if (pageData && pageData.length) {
                allPageData['new' + currentStage] = classifyArr(allPageData[currentStage], 'category');
            } else {
                allPageData['new' + currentStage] = [];
            }
            state.knowledgePoint.hasAdd = true;
        },
        // 将所选问题从试题篮中移除 mutations
        [TypesHandout.HANDOUT_KB_OUT_BASKET](state, payload) {
            // payload 参数 pointId (备课知识点ID) difficulty (备课知识点难度) questionId 问题ID
            const STAGE_ENUM = ['newpreLessonQuestions', 'newwithinLessonQuestions', 'newpracticeLessonQuestions']; // 删除state knowledgePoint中的数据
            const STAGE_ENUM_BASKET = ['preLessonQuestions', 'withinLessonQuestions', 'practiceLessonQuestions'];
            let currentStage = STAGE_ENUM[payload.stage];
            let currentStageBasket = STAGE_ENUM_BASKET[payload.stage];
            let basketIdx = '';
            if (state.basket[payload.pointId]) {
                basketIdx = _.findIndex(state.basket[payload.pointId][currentStageBasket], { id: payload.questionId });
            } else {
                basketIdx = -1;
            }
            if (basketIdx > -1) {
                state.basket[payload.pointId][currentStageBasket].splice(basketIdx, 1);
            }
            // 移除各个难度下的相应 知识点
            let currentPoint = state.knowledgePoint;
            currentPoint[currentStage].forEach(item => {
                let pointIdx = _.findIndex(item.value, questionItem => {
                    return +questionItem.id === +payload.questionId;
                });
                if (pointIdx > -1) {
                    item.value.splice(pointIdx, 1);
                }
            });

            let pointStageIdx = _.findIndex(currentPoint[currentStageBasket], questionItem => {
                return +questionItem.id === +payload.questionId;
            });
            if (pointStageIdx > -1) {
                currentPoint[currentStageBasket].splice(pointStageIdx, 1);
            }
        },
        [TypesHandout.HANDOUT_SET_DELETECHECKQUES](state, payload) {
            /**
             * payload: [
                    {cateName: '例题', checkArr: []},
                    {cateName: '习题', checkArr: []}
                ]
                checkArr: [{
                        name: val1[index].name, // 考法名
                        che: []
                    }]
             */
            state.deleteCheckQue = payload;
            // 处理习题和例题考法排序不规则的情况
            let categoryArr = state.categoryArray; // 考法列表
            let deleteCheck = state.deleteCheckQue;
            for (let m = 0; m < 2; m++) {
                let deleteAry = [];
                for (let i = 0; i < categoryArr.length; i++) {
                    for (let j = 0; j < deleteCheck[m]['checkArr'].length; j++) {
                        if (deleteCheck[m]['checkArr'][j] && categoryArr[i].name === deleteCheck[m]['checkArr'][j].name) { // 找到相同考法项
                            deleteAry[i] = deleteCheck[m]['checkArr'][j];
                        }
                    }
                }
                deleteCheck[m]['checkArr'] = deleteAry; // 将checkArr按categoryArray中考法顺序重新排序
            }
        },
        [TypesHandout.HANDOUT_SET_DELETEALL_LEN](state, payload) {
            state.stateQuestionLen = payload;
        }
    },
    actions: {
        // 获取课件详情 actions
        [TypesHandout.HANDOUT_GET_DETAIL](ctx, coursewareId) {
            return Vue.http.get(`/v1/online-coursewares/${coursewareId}`).then(resp => {
                return Vue.checkResp(resp, {});
            }).then(data => {
                let info = {
                    coursewareId: data.id,
                    name: data.name,
                    studentName: data.studentName,
                    teacherId: data.teacherId,
                    studentId: data.studentId,
                    knowledgePoint: data
                };
                ctx.commit(TypesHandout.HANDOUT_SET_DETAIL, info);
                return data;
            }).catch((err) => {
                ctx.commit(TypesHandout.HANDOUT_SET_DETAIL, null);
                throw err;
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_handout.js